import { createFileRoute, redirect, useLocation } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { ArticleEditorLayout } from "@/components/stealth-writer/result";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";

export const Route = createFileRoute("/_app/stealth-ai-writer/result")({
  component: RouteComponent,
  beforeLoad({ location: { state } }) {
    if (!state.result || !state.fieldsData)
      throw redirect({ to: "/stealth-ai-writer/generate-article" });
  },
});

function RouteComponent() {
  const {
    state: { result: locationResult, fieldsData },
  } = useLocation();

  const plan = useSuspenseQuery(userPlanQueryOptions);

  // TODO: get @jmlhsynv to handle missing plan info
  return (
    <ArticleEditorLayout
      result={locationResult!}
      fieldsData={fieldsData ?? null}
      plan={plan.data.info!}
    />
  );
}
